import { selector } from "recoil";
import { userAtom } from "./State";
import { IUser } from "@interfaces/Interfaces";

export const userNameSelector = selector<string>({
  key: "userNameSelector",
  get: async ({ get }) => {
    const user: IUser | null = await get(userAtom);

    if (!user) return "";

    return user.userData.userName;
  },
});

export const initialFilenameSelector = selector<string>({
  key: "initialFilenameSelector",
  get: async ({ get }) => {
    const user: IUser | null = await get(userAtom);

    if (!user) return "Untitled";

    return `${user.userData.userName?.replace(/\s/gi, "-") || "Untitled"}`;
  },
});
